const intstate = {
  status: "success",
  message: "",
  legacy: {},
  doe: [],
  fix_option: { status: "success", invalid_option_packages: [] },
  refrigerant: "",
  fulldesc: "",
  rules: {},
  newmodel: { status: "success", message: "", doe: {} },
  buildmodel: { status: "success", message: "", doe: {} }
};
const compareReducer = (state = intstate, action) => {
  switch (action.type) {
    case "LOAD_MODEL_NO":
      return { ...state, ...action.compare_data };
    case "LOAD_MODEL_NO_ERROR":
      let loadmodel_tmp = { ...state };
      loadmodel_tmp.message = action.message;
      loadmodel_tmp.status = action.status;
      loadmodel_tmp.legacy = {};
      loadmodel_tmp.doe = [];
      return loadmodel_tmp;
    case "LOAD_NEW_MODEL_NO":
      let t1 = { ...state };
      t1.newmodel = { ...action.compare_data };
      return t1;
    case "LOAD_NEW_MODEL_NO_ERROR":
      let t2 = { ...state };
      t2.newmodel.status = action.status;
      t2.newmodel.message = action.message;
      t2.newmodel.doe = {};
      return t2;

    case "FIX_OPTION_PACKAGES":
      let tfix = { ...state };
      tfix.fix_option = { ...action.to_fix };
      return tfix;
    case "FIX_OPTION_PACKAGES_ERROR":
     var a = "";
    case "LOAD_BUILD_MODEL_NO":
      let tb1 = { ...state };
      tb1.buildmodel = { ...action.compare_data };
      return tb1;

    case "LOAD_NOMENCLATURE":
      return { ...state, nomenclature: action.nomenclature };
    case "LOAD_RULES":
      return { ...state, rules: action.rules };
    case "LOAD_FILE":
      return { ...state, fulldesc: action.fulldesc };

    case "LOAD_BUILD_MODEL_NO_ERROR":
      let teb1 = { ...state };
      teb1.buildmodel.status = action.status;
      teb1.buildmodel.message = action.message;
      return teb1;
    default:
      return {
        ...state
      };
  }
};

export default compareReducer;
